import { useState } from 'preact/hooks';
import { useField, FieldValidator, Field } from 'formik';
import { FieldError } from './FieldError';
import { ChevronIcon } from '../ecardsPreact.icons/ChevronIcon';
import { ClockIcon } from '../ecardsPreact.icons/ClockIcon';
import { TickIcon } from '../ecardsPreact.icons/TickIcon';

export const FormField = ({ label, type, children, wrapperClass, onChange, characterLimit, ...props }) => {
    const [field, meta, helpers] = useField(props);
    const fieldClassName = `form-field form-field--${type}${meta.error && meta.touched ? ' form-field--error' : ''}${wrapperClass ? ` ${wrapperClass}` : ''}`;
    const inputClassName = `form-field__input form-field__input--${type} input`;
    const [charactersLeft, setCharactersLeft] = useState(characterLimit);

    function handleChange(e) {
        helpers.setTouched(true);

        if (onChange) {
            onChange(e);
        } else {
            field.onChange(e);
        }

        if (charactersLeft !== undefined) {
            handleCharacterLimit(e.target.value);
        }
    }

    function handleBlur(e) {
        if (charactersLeft !== undefined) {
            handleCharacterLimit(e.target.value);
        }
    }

    function handleCharacterLimit(value) {
        const currentLength = value.length;
        const remaining = characterLimit - currentLength ?? characterLimit;

        setCharactersLeft(remaining <= 0 ? 0 : remaining);

        if (remaining <= 0) {
            helpers.setValue(value.substr(0, characterLimit));
        }
    }

    let input = null;

    switch (type) {
        case 'text':
        case 'email':
        case 'tel':
            input = <Field type={type} class={inputClassName} id={field.name} {...field} {...props} onChange={handleChange} onBlur={handleBlur} />;
            break;

        case 'textarea':
            input = <Field as={type} class="textarea" id={field.name} {...field} {...props} onChange={handleChange} onBlur={handleBlur} />;
            break;

        case 'checkbox':
            input = (
                <Field
                    type={type}
                    class="checked-item__input"
                    id={field.name}
                    {...field}
                    {...props}
                    checked={field.value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
            );
            break;

        case 'select':
            input = (
                <div class="select">
                    <Field
                        as="select"
                        class="form-field__input input input--select"
                        id={field.name}
                        {...field}
                        {...props}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        {children}
                    </Field>

                    <ChevronIcon width="16" height="16" class="select__arrow" />
                </div>
            );

        case 'time':
            input = (
                <div class="select form-field__icon-wrapper">
                    <ClockIcon width="24" height="24" class="form-field__icon text-blue" />

                    <Field
                        as="select"
                        class="form-field__input input input--select"
                        id={field.name}
                        {...field}
                        {...props}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        {children}
                    </Field>

                    <ChevronIcon width="16" height="16" class="select__arrow" />
                </div>
            );
    }

    if (type === 'checkbox') {
        return (
            <div class={`checked-item ${wrapperClass}`}>
                {input}
                <label class="checked-item__label label" htmlFor={field.name}>
                    <span class="checked-item__icon">
                        <TickIcon width="12" height="12" class="icon-tick" />
                    </span>
                    {label}
                </label>
                <FieldError {...meta} />
            </div>
        );
    } else {
        return (
            <div class={fieldClassName}>
                <div class="form-field__label-wrapper">
                    <label class="form-field__label label" htmlFor={field.name}>
                        {label}

                        {props.required && <span class="label__required">&nbsp;*</span>}
                    </label>
                    {characterLimit !== undefined && (
                        <p class={`form-field__character-limit${charactersLeft <= 40 ? ' text-error-red' : ''}`}>Characters left: {charactersLeft}</p>
                    )}
                </div>

                {input}
                <FieldError {...meta} />
            </div>
        );
    }
};
